export default "__VITE_ASSET__UxZswsAE__"